export type BackendStatus = 'waiting' | 'completed' | 'abandoned' | 'absent' | 'cancelled';
export type FrontendDisplay = 'na_fila' | 'concluido' | 'desistente' | 'ausente' | 'cancelado';

export interface StatusConfig {
  backendValue: BackendStatus;
  frontendDisplay: FrontendDisplay;
  labelPtBr: string;
  color: string;
  icon: string;
  description: string;
  tailwindClasses: string;
}

export const statusMapping: Record<BackendStatus, StatusConfig> = {
  waiting: {
    backendValue: 'waiting',
    frontendDisplay: 'na_fila',
    labelPtBr: 'Na Fila',
    color: 'blue',
    icon: 'Clock',
    description: 'Participante aguardando atendimento',
    tailwindClasses: 'bg-primary/10 text-primary border-primary'
  },
  completed: {
    backendValue: 'completed',
    frontendDisplay: 'concluido',
    labelPtBr: 'Concluído',
    color: 'green',
    icon: 'CheckCircle',
    description: 'Atendimento finalizado com sucesso',
    tailwindClasses: 'bg-brand-green/10 text-status-ok border-brand-green'
  },
  abandoned: {
    backendValue: 'abandoned',
    frontendDisplay: 'desistente',
    labelPtBr: 'Desistente',
    color: 'orange',
    icon: 'XCircle',
    description: 'Participante abandonou a fila',
    tailwindClasses: 'bg-brand-attention/10 text-status-attention border-brand-attention'
  },
  absent: {
    backendValue: 'absent',
    frontendDisplay: 'ausente',
    labelPtBr: 'Ausente',
    color: 'gray',
    icon: 'UserX',
    description: 'Participante não compareceu quando chamado',
    tailwindClasses: 'bg-muted text-muted-foreground border-border'
  },
  cancelled: {
    backendValue: 'cancelled',
    frontendDisplay: 'cancelado',
    labelPtBr: 'Cancelado',
    color: 'red',
    icon: 'Ban',
    description: 'Participação cancelada pelo sistema/admin',
    tailwindClasses: 'bg-brand-danger/10 text-status-danger border-brand-danger'
  }
};

export function mapStatusToDisplay(status: string): FrontendDisplay {
  return statusMapping[status as BackendStatus]?.frontendDisplay || 'na_fila';
}

export function getStatusDisplay(status: string): StatusConfig {
  return statusMapping[status as BackendStatus] || statusMapping.waiting;
}

export function getStatusMessage(status: string): string {
  const messages: Record<BackendStatus, string> = {
    waiting: 'Você está na fila de espera',
    completed: 'Atendimento concluído. Obrigado!',
    abandoned: 'Você saiu da fila',
    absent: 'Você foi marcado como ausente',
    cancelled: 'Sua participação foi cancelada'
  };
  
  return messages[status as BackendStatus] || 'Status atualizado';
}

export function getStatusContextualMessage(status: string, position?: number): string {
  const baseMessage = getStatusMessage(status);
  
  if (status === 'waiting' && position) {
    return `Você está na posição #${position}`;
  }
  
  return baseMessage;
}